// extracted by mini-css-extract-plugin
export default {"fileBox":"JanUQRB2QedfIsh5wy6B","uploadBtn":"DDan4rHmmjtO9oiLetdN"};